/**
 * Formats a seconds duration as "Hh Mm" for display, mirroring the Angular
 * source's CommonService.getHourMinuteSecondFromSeconds(value, true) used on
 * the overtime manager table (Taken/Requested/Remaining columns).
 */
export const formatSecondsAsHoursMinutes = (totalSeconds: number | undefined | null): string => {
  if (!totalSeconds || totalSeconds <= 0) return '0h 0m';
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  return `${hours}h ${minutes}m`;
};

/** Like `formatSecondsAsHoursMinutes`, but keeps the sign: ledger changes and balances go negative. */
export const formatSignedHoursMinutes = (totalSeconds: number | undefined | null): string => {
  const value = Math.round(totalSeconds ?? 0);
  return value < 0 ? `-${formatSecondsAsHoursMinutes(-value)}` : formatSecondsAsHoursMinutes(value);
};
